import { render, staticRenderFns } from "./SeleccionarAsientosComponent.vue?vue&type=template&id=621aefe1"
import script from "./SeleccionarAsientosComponent.vue?vue&type=script&lang=js"
export * from "./SeleccionarAsientosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports